function initReadMore() {
  var wrappers = document.querySelectorAll('[data-read-more-wrapper]');

  wrappers.forEach(function (wrapper) {
    var content = wrapper.querySelector('.read-more-content');
    var btn = wrapper.querySelector('.read-more-btn');

    if (!content || !btn) return;

    if (content.classList.contains('is-expanded')) return;

    if (content.scrollHeight > content.clientHeight) {
      btn.style.display = 'block';
    } else {
      btn.style.display = 'none';
    }
  });
}

function toggleReadMore(btn) {
  var wrapper = btn.closest('[data-read-more-wrapper]');
  var content = wrapper.querySelector('.read-more-content');

  content.classList.toggle('is-expanded');

  if (content.classList.contains('is-expanded')) {
    btn.innerText = btn.getAttribute('data-text-close');
  } else {
    btn.innerText = btn.getAttribute('data-text-open');
  }
}

window.initReadMore = initReadMore;
window.toggleReadMore = toggleReadMore;

document.addEventListener('DOMContentLoaded', function () {
  initReadMore();
  window.addEventListener('resize', initReadMore);
});
